import { TAccessPolicy } from '@ocm_customer/account_pro-ui-access';

/**
 * Function is made to return boolean value based on policy doc
 * and user creds.
 * Returns false if policy doc has purchaserPHFilter with matching role and type, otherwise true
 */
export const isUserAllowedToViewAllPurchases = (
  role: string,
  type: string,
  rules: TAccessPolicy[],
): boolean => {
  let shouldRender = true;

  if (type === 'b2b') {
    rules.forEach((rule: TAccessPolicy) => {
      if (
        rule.actions.includes('view') &&
        rule.resources[0] === 'order' &&
        rule.filters
      ) {
        shouldRender = !rule.filters.find(
          ({ name, filterCandidate }) =>
            name === 'purchaserPHFilter' &&
            filterCandidate?.user?.role === role.toUpperCase() &&
            filterCandidate?.user?.type === type.toUpperCase(),
        );
      }
    });
  }

  return shouldRender;
};
